export default {"src":"/_next/static/media/AppDownloadAppStore.365aa9c6.svg","height":61,"width":192,"blurWidth":0,"blurHeight":0};